import { all, call, put, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* post(action) {
    const { auditArchive } = action.payload;
    const url = config.api.paths.auditArchive;
    try {
        const { data } = yield call(http.authorized.post, url, auditArchive);
        yield put(actionCreators.postSuccess(data));
    } catch (error) {
        logToSentry("On audit archive post:", { error });
        console.error(error);
        yield put(actionCreators.postFailure(error));
    }
}

export default function* () {
    yield all([takeLatest(actionTypes.AUDIT_ARCHIVE_POST_REQUEST, post)]);
}
